import {SerializedError} from '@reduxjs/toolkit';
import {getSerializedPagewebError} from './getSerializedPagewebError.function';
import {SerializedPagewebError} from './SerializedPagewebError.interface';

/**
 * SerializedPagewebError 를 Error 객체로 나타내기 위한 클래스입니다
 * 주로 throw 할 때 감싸기 위함입니다. SerializedPagewebError 로 throw 할 경우 stacktrace 를 볼 수 없기 때문에 throw 할 땐 항상 new PagewebError() 로 감싸야합니다
 */
export class PagewebError extends Error {
  public readonly serializedError: SerializedPagewebError;

  constructor(error: SerializedPagewebError | SerializedError) {
    super(error.message);
    if ('isSerializedPagewebError' in error) {
      this.serializedError = error;
    } else {
      // rtk-query 에서 SerializedPagewebError로 변환해주고 있어 else문으로 분기될 수 없지만
      // rtk-query에서 error를 SerializedError | SerializedPagewebError 두가지 유니온 type으로 추론되고 있어 다음과 같이 처리합니다.
      // 문서에서도 프로퍼티를 통해 타입 체크를 해주고 있어 제네릭하게 처리되지 않는 거 같습니다.
      // https://redux-toolkit.js.org/rtk-query/usage-with-typescript#type-safe-error-handling
      this.serializedError = getSerializedPagewebError(error);
    }
  }
}
